module.exports = __webpack_public_path__ + "static/media/mytarget.2098d551.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/CreateCampaign/components/CreateCampaignForm/assets/mytarget.svg
// module id = 1286
// module chunks = 0